import { render } from "./SplashWrapper.vue.js?vue&type=template&id=03305a12&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashWrapper.vue?vue&type=template&id=03305a12&scoped=true"
import script from "./SplashWrapper.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashWrapper.vue?vue&type=script&lang=js"
export * from "./SplashWrapper.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashWrapper.vue?vue&type=script&lang=js"

import "./SplashWrapper.vue.scss?vue&type=style&index=0&id=03305a12&scoped=true&lang=scss!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashWrapper.vue?vue&type=style&index=0&id=03305a12&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03305a12"],['__file',"src/Web/scripts/components/splash/SplashWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "03305a12"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('03305a12', __exports__)) {
    api.reload('03305a12', __exports__)
  }
  
  module.hot.accept("./SplashWrapper.vue.js?vue&type=template&id=03305a12&scoped=true!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SplashWrapper.vue?vue&type=template&id=03305a12&scoped=true", () => {
    api.rerender('03305a12', render)
  })

}


export default __exports__